import React from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const defaultMembers = [
  { name: "", designation: "", message: "", image: "" },
  { name: "", designation: "", message: "", image: "" },
];

const LeadershipProfilesSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();
  const members = data.members?.length === 2 ? data.members : defaultMembers;

  const handleSectionChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value,
    });
  };

  const updateMember = (index, field, value) => {
    const updatedMembers = members.map((member, i) =>
      i === index ? { ...member, [field]: value } : member
    );

    onUpdate({
      ...data,
      members: updatedMembers,
    });
  };

  const handleImageUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        updateMember(index, "image", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const handleMiddleImageUpload = async (file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleSectionChange("middleImage", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Leadership Profiles Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleSectionChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={6}>
              <div className="border rounded p-3 h-100 mb-3 mb-md-0">
                <h6 className="mb-3">Profile 1</h6>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={members[0].name}
                    onChange={(e) =>
                      updateMember(0, "name", e.target.value)
                    }
                    placeholder="Enter name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    value={members[0].designation}
                    onChange={(e) =>
                      updateMember(0, "designation", e.target.value)
                    }
                    placeholder="Enter designation"
                  />
                </Form.Group>
                <Form.Group className="mb-0">
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      e.target.files?.[0] &&
                      handleImageUpload(0, e.target.files[0])
                    }
                  />
                  {isUploading && (
                    <div className="text-muted small mt-1">Uploading...</div>
                  )}
                  {members[0].image && (
                    <div className="mt-2">
                      <Image
                        src={members[0].image}
                        alt="Profile 1"
                        thumbnail
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                  )}
                </Form.Group>
              </div>
            </Col>

            <Col md={6}>
              <div className="border rounded p-3 h-100 mb-3 mb-md-0">
                <h6 className="mb-3">Profile 2</h6>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={members[1].name}
                    onChange={(e) =>
                      updateMember(1, "name", e.target.value)
                    }
                    placeholder="Enter name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    value={members[1].designation}
                    onChange={(e) =>
                      updateMember(1, "designation", e.target.value)
                    }
                    placeholder="Enter designation"
                  />
                </Form.Group>
                <Form.Group className="mb-0">
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      e.target.files?.[0] &&
                      handleImageUpload(1, e.target.files[0])
                    }
                  />
                  {isUploading && (
                    <div className="text-muted small mt-1">Uploading...</div>
                  )}
                  {members[1].image && (
                    <div className="mt-2">
                      <Image
                        src={members[1].image}
                        alt="Profile 2"
                        thumbnail
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                  )}
                </Form.Group>
              </div>
            </Col>
          </Row>

          <div className="border rounded p-3 mt-4">
            <h6 className="mb-3">Middle Image</h6>
            <Form.Group className="mb-0">
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) =>
                  e.target.files?.[0] &&
                  handleMiddleImageUpload(e.target.files[0])
                }
              />
              {isUploading && (
                <div className="text-muted small mt-1">Uploading...</div>
              )}
              {data.middleImage && (
                <div className="mt-2">
                  <Image
                    src={data.middleImage}
                    alt="Middle"
                    thumbnail
                    style={{ maxWidth: "200px" }}
                  />
                </div>
              )}
            </Form.Group>
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default LeadershipProfilesSection;
